import React, { useState, useEffect } from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./Personajes.css";
import { getPersonajes, getConfigPagina, isApiConfigured } from "../services/api";
import ContenidoExtra from "../components/ContenidoExtra";

import img1 from "../pages/assets/img/imagenes personajes/PersonajeBalloon.png";
import img2 from "../pages/assets/img/imagenes personajes/PersonajeBen.png";
import img3 from "../pages/assets/img/imagenes personajes/PersonajeRino.png";
import img4 from "../pages/assets/img/imagenes personajes/PersonajeJirrafael.png";
import img5 from "../pages/assets/img/imagenes personajes/PersonajeAlfonzorro.png";
import img6 from "../pages/assets/img/imagenes personajes/PersonajeTite.png";
import img7 from "../pages/assets/img/imagenes personajes/PersonajeLaArdilla.png";
import img8 from "../pages/assets/img/imagenes personajes/PersonajeElCastor.png";

const defaultPersonajes = [
  { nombre: "Balloon",    img: img1 },
  { nombre: "Ben",        img: img2 },
  { nombre: "Rino",       img: img3 },
  { nombre: "Jirrafael",  img: img4 },
  { nombre: "Alfonzorro", img: img5 },
  { nombre: "Tite",       img: img6 },
  { nombre: "La Ardilla", img: img7 },
  { nombre: "El Castor",  img: img8 },
];

function Personajes() {
  const [personajes, setPersonajes] = useState(defaultPersonajes);
  const [config, setConfig] = useState({ titulo: null, subtitulo: null, contenido_extra: null, personajes_grid_titulo: null });
  const shouldReduceMotion = useReducedMotion();

  const sectionVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.2 : 0.6,
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: shouldReduceMotion ? 0 : 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: shouldReduceMotion ? 0 : 24 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: shouldReduceMotion ? 0.2 : 0.5, ease: "easeOut" },
    },
  };

  useEffect(() => {
    if (!isApiConfigured()) return;
    getPersonajes()
      .then((data) => {
        if (data && data.length > 0) {
          setPersonajes(data.map((p) => ({
            nombre: p.nombre,
            img: p.imagen || null,
          })).filter((p) => p.img));
        }
      })
      .catch(() => {});
    getConfigPagina("personajes")
      .then((cfg) => { if (cfg) setConfig(cfg); })
      .catch(() => {});
  }, []);

  return (
    <div className="personajes">
      <motion.div
        initial="hidden"
        animate="show"
        variants={sectionVariants}
      >
        <motion.div className="personajes-wrapper" variants={itemVariants}>
          <h1 className="personajes-title">{config.titulo || "¡Te presentamos el mundo Balloon y Ben!"}</h1>
        </motion.div>
        <motion.div className="personajes-descripciones" variants={itemVariants}>
          <h3 className="personajes-descripcion">{config.subtitulo || "Acompaña a cada personaje en su presentación: qué sueñan, qué temen y cómo, juntos, transforman cada pequeño reto en una gran aventura."}</h3>
        </motion.div>
        <ContenidoExtra html={config.contenido_extra} variants={itemVariants} />
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
        variants={sectionVariants}
      >
        <motion.div className="per-personajes" variants={itemVariants}>
          <h1 className="per-personaje">{config.personajes_grid_titulo || "Personajes"}</h1>
        </motion.div>
        <div className="personajes-grid">
          {personajes.map((p, index) => (
            <motion.div key={index} className="personaje-card" variants={itemVariants}>
              <img src={p.img} alt={p.nombre} className="personaje-img" />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}

export default Personajes;
